import {Injectable} from "@angular/core";
import {AuthState, AuthStore} from "./auth.store";
import {User} from "../../data-access/api-users/User";
import {AuthUtil} from "../../shared/utils/auth.util";
import {EdgeService} from "../../data-access/api-auth/edge.service";
import {UserService} from "../../data-access/api-users/user.service";
import {catchError, EMPTY, filter, finalize, first, Observable, switchMap, tap} from "rxjs";
import {AuthService} from "@auth0/auth0-angular";


@Injectable({ providedIn: 'root' })
export class EdgeAuthService {
  constructor(
    private store: AuthStore,
    private edgeService: EdgeService,
    private userService: UserService,
    private authService: AuthService,
  ) { }

  public setLoading(isLoading: boolean): void {
    this.store.setLoading(isLoading);
  }

  public refresh(): void {
    this.authService.isLoading$
      .pipe(
        filter((loading: boolean) => !loading),
        switchMap(() => this.authService.isAuthenticated$),
        first(),
        switchMap((isAuth: boolean) => {
          if (!isAuth) {
            this.authService.loginWithRedirect({ appState: { target: '/services'} });
            return EMPTY;
          }
          return this.initAuthValue$();
        }),
        finalize(() => this.setLoading(false)),
        catchError((err) => {
          console.error('[bootstrap edge service] init failed', err);
          return EMPTY;
        })
      ).subscribe();
  }

  private initAuthValue$(): Observable<any> {
    return this.edgeService.me()
      .pipe(
        switchMap((me: any) => {
          const subject = me?.sub ?? me?.subject; // support both during migration
          if (!subject) {
            throw new Error('Missing subject in /me');
          }
          return this.userService.getMe(subject);
        }),
        tap((user: User) => this.authorizedUser(user)),
        catchError(err => {
          this.rejectUser(err);
          return EMPTY;
        })
      );
  }

  private authorizedUser(user: User): void {
    const authorizedUser: User = AuthUtil.User(user);
    this.store.update((state: AuthState) => ({
      ...state,
      ...authorizedUser
    }));
  }

  private rejectUser(error?: any): void {
    if (error) {
      this.store.setError(error)
    }
    const rejectedUser: User = User.ANONYMOUS;
    this.store.update((state: AuthState) => ({
      ...state,
      ...rejectedUser
    }));
  }

}
